import { InfoFormItem, PageFormItem, useFormDialog } from "../../../components/form-item/client/components";
import { FormProps } from "../../../components/form-item/framework/react/FormProvider";
import { OnboardingTaskDocument } from "../../../task/task.model";
import { CheckCompanySigningForm, useCheckCompanySigningForm } from "../../shared/CheckCompanySigningForm";
import { GardenerDocument } from "../../../gardener/gardener.model";
import { CheckApplicationForm, useCheckApplicationForm } from "../../shared/CheckApplicationForm";
import { SupportedCompany } from "../../../company/company.model";
import { useCheckApplicantNameForm } from "../../shared/CheckApplicantNameForm";

export enum ApplicationResponseFormIds {
    SingleChoiceSeriousApplication = "SingleChoiceSeriousApplication",
    SingleChoiceApplicationInDanish = "SingleChoiceApplicationInDanish",
    SingleChoiceHasExperience = "SingleChoiceHasExperience",
    SingleChoiceValidName = "SingleChoiceValidName",
    SingleChoiceCanSignForCompany = "SingleChoiceCanSignForCompany",
}

export type ApplicationResponseForm =
    CheckApplicationForm<
        CheckCompanySigningForm<
            ConfirmationPage
        >
    >

type ConfirmationPage = PageFormItem<InfoFormItem>

export const useApplicationResponseDialog = (gardener: GardenerDocument, company: SupportedCompany | null, task: OnboardingTaskDocument, onConfirm: FormProps<ApplicationResponseForm>["onSubmit"]) => {
    
    const confirmationPage: ConfirmationPage = {
        type: "page",
        title: "Godkend ansøgning",
        item: {
            type: "info",
            render: "default",
            text: `
                Du godkender ansøgningen og giver havemanden mulighed for at acceptere 3 opgaver.<br />
                <br />
                Ansøgeren informeres om, at de nu kan aktivere deres profil.
            `,
        },
    };

    const checkCompanySigningForm = useCheckCompanySigningForm(gardener, company, confirmationPage, {
        SingleChoiceCanSignForCompany: ApplicationResponseFormIds.SingleChoiceCanSignForCompany,
    });

    const checkApplicantNameForm = useCheckApplicantNameForm(gardener, checkCompanySigningForm, {
        SingleChoiceValidName: ApplicationResponseFormIds.SingleChoiceValidName,
    });

    const checkApplicationForm = useCheckApplicationForm(task, checkApplicantNameForm, {
        SingleChoiceSeriousApplication: ApplicationResponseFormIds.SingleChoiceSeriousApplication,
        SingleChoiceApplicationInDanish: ApplicationResponseFormIds.SingleChoiceApplicationInDanish,
        SingleChoiceHasExperience: ApplicationResponseFormIds.SingleChoiceHasExperience,
    });

    return useFormDialog(checkApplicationForm, onConfirm);
};
